import { Session } from "@talkjs/react"
import { useCallback } from "react"
import Talk from "talkjs"

import { useMe } from "../../hooks/api"
import { useTalkJS } from "../../hooks/api/talk-js"

const ProviderContent = ({
  children,
  seller,
}: {
  children: React.ReactNode
  seller: any
}) => {
  const { app_id, isLoading } = useTalkJS()
  const syncUser = useCallback(() => {
    return new Talk.User({
      id: seller?.id || "",
      name: seller?.name || "",
      email: seller?.email || null,
      photoUrl: seller?.photo || "/talkjs-placeholder.jpg",
    })
  }, [seller])

  if (!app_id || !seller || isLoading) return <>{children}</>

  return (
    <Session appId={app_id} syncUser={syncUser}>
      {children}
    </Session>
  )
}

export const TalkjsProvider = ({ children }: { children: React.ReactNode }) => {
  const { seller, isPending } = useMe()

  if (isPending)
    return <div className="flex justify-center items-center h-screen" />

  return <ProviderContent seller={seller}>{children}</ProviderContent>
}
